module.exports = __webpack_public_path__ + "img/pic-01.045c7166.png";